import { usePostProfileVerifyEmailChangeMutation } from '@/api/serverApi'
import { LoadingSpinner, Meta } from '@cfs-fixings/shared'
import toastHelper from '@cfs-fixings/shared/src/helpers/toastHelper'
import { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

const textSpec = {
  successToastMessage: {
    title: 'Email Verified Successfully',
    body: 'Your email has now been changed.',
  },
  errorToastMessage: {
    title: 'Something went wrong',
    body: 'Please ensure the link used is correct or try again later.',
  },
}

function VerifyEmailChangePage () {
  const isFirstRender = useRef(true)

  const [searchParams] = useSearchParams()

  const navigate = useNavigate()

  const [verifyEmail, { isLoading }] = usePostProfileVerifyEmailChangeMutation()

  useEffect(() => {
    // Prevents duplicate requests on first render
    if (!isFirstRender.current) {
      return
    }

    isFirstRender.current = false

    const token = searchParams.get('token') ?? ''
    const email = searchParams.get('email') ?? ''

    if (!isLoading) {
      verifyEmail({
        body: {
          token,
          email,
        },
      })
        .unwrap()
        .then((_) => {
          toastHelper.success(textSpec.successToastMessage.title, textSpec.successToastMessage.body)
          navigate('/profile')
        })
        .catch((error) => {
          toastHelper.error(textSpec.errorToastMessage.title, error.data?.message ?? textSpec.errorToastMessage.body)
        })
    }
  }, [isLoading, navigate, searchParams, verifyEmail])

  return <>
    <Meta title="Verify New Email" />

    <div className="w-full flex items-center justify-center">
      <LoadingSpinner className="h-4 w-4" />
    </div>
  </>
}

export default VerifyEmailChangePage
